export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5497.645c2c78.jpg";